import { useMutation } from '@tanstack/react-query';
import { rpcClient } from '@/api/rpc/client';

/**
 * Whole-canvas layout generation ("prompt the canvas"). No cache interaction:
 * results land in the canvas edit draft, never a query cache.
 */
export function useGenerateCanvasLayout() {
  return useMutation({
    mutationFn: rpcClient.core.reportCanvasAi.generateCanvasLayout,
  });
}
